import { render } from "./Table.vue?vue&type=template&id=04c86c16&scoped=true&bindings={\"standing\":\"data\",\"title\":\"data\",\"getTableData\":\"options\"}"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=04c86c16&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04c86c16"

export default script